import React from 'react';
import Sort from './Sort.svg';

export default props => <img src={Sort} alt="sort" {...props} />;
